// Get icons from https://svgl.app
import javacript from "../assets/icons/javascript.svg";
import typescript from "../assets/icons/typescript.svg";
import html5 from "../assets/icons/html5.svg";
import react from "../assets/icons/react.svg";
import python from "../assets/icons/python.svg";
import nextjs from "../assets/icons/next-js.svg";
import nodejs from "../assets/icons/nodejs.svg";
import tailwind from "../assets/icons/tailwind.svg";
import vercel from "../assets/icons/vercel.svg";
import aws from "../assets/icons/aws.svg";
import postgresql from "../assets/icons/postgresql.svg";
import css from "../assets/icons/css.svg";

export const skills = [
  { id: 1, name: "React", icon: react },
  { id: 2, name: "Next.js", icon: nextjs },
  { id: 3, name: "JavaScript", icon: javacript },
  { id: 4, name: "TypeScript", icon: typescript },
  { id: 5, name: "HTML5", icon: html5 },
  { id: 6, name: "CSS", icon: css },
  { id: 7, name: "Tailwind", icon: tailwind },
  { id: 8, name: "React Native", icon: react },
  { id: 9, name: "PostgreSQL", icon: postgresql },
  { id: 10, name: "Python", icon: python },
  { id: 11, name: "Node.js", icon: nodejs },
  { id: 12, name: "AWS", icon: aws },
  { id: 13, name: "Vercel", icon: vercel },
];
